export function appendPacificOffset(isoString: string) {
  // Check if string already has an offset
  if (/[Z+-]/.test(isoString.slice(-6))) {
    return isoString;
  }

  // Get current Pacific offset
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return 'N/A';
  }

  // Get Pacific time offset
  const pacificDate = new Date(date.toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles'
  }));
  const utcDate = new Date(date.toLocaleString('en-US', {
    timeZone: 'UTC'
  }));

  // Calculate offset in hours
  const offsetHours = ((pacificDate.getTime() - utcDate.getTime()) / (1000 * 60 * 60));

  // Format the offset as -07:00 or -08:00
  const offsetStr = offsetHours <= -10 ? `${offsetHours}:00` : `-0${-offsetHours}:00`;

  return  `${isoString}${offsetStr}`;
}

export function appendUTCOffset(isoString: string) {
  // Check if string already has an offset
  if (/[Z+-]/.test(isoString.slice(-6))) {
    return isoString;
  }
  return `${isoString}Z`;
}
